import React from 'react';
import Header from './Header/Header';

interface ILayoutProps {
  children: React.ReactNode;
  className?: string;
}

export default function Layout({ children, className }: ILayoutProps) {
  return (
    <div>
      <Header />
      <div className={`pt-16 mx-auto lg:px-[15%] px-[5%] ${className}`}>
        {children}
      </div>
    </div>
  );
}
